<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.pkid ? '编辑' : (pageType ? '新建一级' : '新建')"
      class="customer-edit"
      width="500px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item label="序号">
        <el-input v-model="model.functionIndex" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="代码">
        <el-input v-model="model.functionNO" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="名称" prop="functionName">
        <el-input v-model="model.functionName" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name:"SystemFunctionEdit",
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        pageType: 0,
        model: {
          pkid: "",
          functionIndex: "",
          functionNO: "",
          functionName: "",
          parentID: "",
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(parentId, id, name, pageType) {
        console.log(name);
        this.model.parentID = parentId;
        this.pageType = pageType;
        this.model.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          console.log(id);
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `functions/${this.model.pkid}`)
          .then(resp => {
            this.model = resp;
          });
      },
      handleSubmit() {
        if(this.model.pkid > 0) {
          this.handleSubmitEdit();
        }else {
          this.handleSubmitCreate();
        }
      },
      handleSubmitEdit() {
        console.log(this.model);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "functions", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitCreate() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "functions", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>
